<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e2382368" style="color: #82a339"><b>TURKEY SOUP</b></p>
<p class="ext" id="d7e2382868"><b><i>What’s the Friday after Thanksgiving without turkey soup? Use your favorite vegetables to personalize this simple recipe.</i></b></p>
<p class="h4" id="d7e2384168" style="color: #496210"><b>Prep: 15 minutes plus overnight to chill Cook: 5 hours</b></p>
<p class="ul" id="d7e2384968">6 carrots, peeled</p>
<p class="ul" id="d7e2385268">3 stalks celery <br/> roasted turkey carcass, plus 2 cups cooked turkey meat, finely chopped</p>
<p class="ul" id="d7e2386168">2 medium onions, each cut into quarters</p>
<p class="ul" id="d7e2386468">5 parsley sprigs</p>
<p class="ul" id="d7e2386868">1 garlic clove, peeled</p>
<p class="ul" id="d7e2387168">¼ teaspoon dried thyme</p>
<p class="ul" id="d7e2388068">½ bay leaf</p>
<p class="ul" id="d7e2389068">6 quarts water</p>
<p class="ul" id="d7e2389368">1¼ teaspoons salt</p>
<p class="ul" id="d7e2390468">1 cup regular long-grain rice, cooked as <br/> label directs</p>
<p class="ul" id="d7e2391168">2 tablespoons fresh lemon juice or</p>
<p class="ul" id="d7e2391468">1 tablespoon dry sherry</p>
<p class="pub" id="d7e2391968" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Cut 2 carrots and 1 stalk celery into 2-inch pieces. In 12-quart stockpot, combine turkey carcass, carrot and celery pieces, onions, parsley sprigs, garlic, thyme, bay leaf, and 6 quarts water or enough water to cover; heat to boiling over high heat. Skim foam from surface. Reduce heat and simmer, skimming occasionally, 4 hours.</p>
<p class="pub" id="d7e2394668"><span style="color: #c15b49"><b>2.</b></span> Strain broth through colander set over large bowl; discard solids. Strain again through sieve into several containers; cool. Cover and refrigerate overnight.</p>
<p class="pub" id="d7e2396068"><span style="color: #c15b49"><b>3.</b></span> Remove and discard fat from surface of broth; measure broth and pour into 5-quart saucepot. If necessary, boil broth over high heat until reduced to 10 cups to concentrate flavor.</p>
<p class="pub" id="d7e2398268"><span style="color: #c15b49"><b>4.</b></span> Cut remaining 4 carrots and remaining 2 stalks celery into ½-inch pieces; add to broth with salt. Heat soup to boiling. Reduce heat and simmer until vegetables are tender, about 15 minutes. Stir in cooked rice and turkey; heat through, about 5 minutes. Remove from heat and stir in lemon juice. Makes about 13 cups or 12 first-course servings.</p>
<p class="ntx" id="d7e2402268">Each serving: About 113 calories, 10g protein, 12g carbohydrate, 2g total fat (1g saturated), 21mg cholesterol, 355mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c72_r1.vue?7165af26